import * as React from 'react';
import MainLayout from '../Layouts/MainLayout';

const PrivTest = () => <MainLayout>Private Test.</MainLayout>;

export default PrivTest;



// WEBPACK FOOTER //
// ./src/containers/Pages/PrivTest.tsx